export default () => ({
  loan: {},
})
